module.exports = __webpack_public_path__ + "img/Stamp.816fcb3d.svg";